import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {createRouter, RouterProvider} from "@tanstack/react-router";
import {Agentation} from "agentation";
import {routeTree} from "./routeTree.gen.js";
import type {RouterContext} from "./routes/__root.js";
import {browserStore, tabStore} from "./setup/storage.js";
import {openingBooks} from "./solver/books.js";
import {SolverClient} from "./solver/client.js";

const context: RouterContext = {
	store: browserStore,
	gameStore: tabStore,
	createSolver: () => new SolverClient(),
	prefetchBook: (rules) => {
		openingBooks.prefetch(rules);
	},
};

const router = createRouter({routeTree, context});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const root = document.getElementById("app");

if (!root) {
	throw new Error("Root element not found");
}

createRoot(root).render(
	<StrictMode>
		<RouterProvider router={router} />
		{import.meta.env.DEV && <Agentation />}
	</StrictMode>,
);
